import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useIsHydrated } from '@hozana/hooks/useIsHydrated'
import { useRouter } from '@hozana/router'

import { closeNavigation } from 'general/actions'
import { FULL_STATIC_PAGES, HEADER_ITEM } from 'general/constants'
import type { THeaderItems } from 'general/types'
import { PAGE } from 'routes/constants'

import type { TCommunity } from 'modules/community/types'
import { useUser } from 'modules/user/hooks/useUser'

export const useHeaderMap = ({ community }: { community: TCommunity; correspondentId?: number }) => {
  const dispatch = useDispatch()
  const isHydrated = useIsHydrated()
  const { isLogged } = useUser()
  const { pathname } = useRouter()
  const [prevLocation, setPrevLocation] = useState<PAGE | undefined>()
  const [isFirstLocation, setIsFirstLocation] = useState(true)

  useEffect(() => {
    if (prevLocation !== pathname) {
      dispatch(closeNavigation())
      if (!([PAGE.AUTH_SOCIAL, PAGE.HOME] as PAGE[]).includes(prevLocation)) {
        setIsFirstLocation(false)
      }
      setPrevLocation(pathname)
    }
  }, [dispatch, pathname, prevLocation])

  const communityItems: HEADER_ITEM[] = [community && HEADER_ITEM.COMMUNITY_JOIN_BUTTONS]
  const connectItems: HEADER_ITEM[] = [
    !isLogged && isHydrated && HEADER_ITEM.LOGIN_BUTTON,
    !isLogged && isHydrated && HEADER_ITEM.SIGN_UP_BUTTON,
    isLogged && HEADER_ITEM.DONATION,
  ]

  const isCommunityPage = ([PAGE.COMMUNITY_VIEW, PAGE.COMMUNITY_VIEW_LANDING] as PAGE[]).includes(pathname)

  const defaultDesktopItems: THeaderItems = {
    left: [
      !FULL_STATIC_PAGES.includes(pathname) && HEADER_ITEM.NAVIGATION_BUTTON,
      !isLogged && isHydrated && !isCommunityPage && HEADER_ITEM.LANGUAGE_ITEM_BLOCK,
    ],
    middle: [],
    right: connectItems,
  }
  const defaultMobileItems: THeaderItems = {
    left: [
      !isFirstLocation ? HEADER_ITEM.GO_BACK : !FULL_STATIC_PAGES.includes(pathname) && HEADER_ITEM.NAVIGATION_BUTTON,
    ],
    middle: [HEADER_ITEM.TITLE_PAGE],
    right: isLogged ? [HEADER_ITEM.DONATION] : [],
  }

  let desktopItems: THeaderItems
  let mobileItems: THeaderItems
  // let mobileBg: keyof DefaultTheme['colors'] = 'transparent' // Keep if necessary
  // let desktopBg: keyof DefaultTheme['colors'] = 'transparent' // Keep if necessary

  switch (pathname) {
    case PAGE.COMMUNITY_VIEW:
    case PAGE.COMMUNITY_VIEW_LANDING:
      mobileItems = {
        right: communityItems,
      }
      desktopItems = {
        left: [HEADER_ITEM.NAVIGATION_BUTTON],
        right: communityItems,
      }
      break

    case PAGE.COMMUNITY_LIST_SEO:
      mobileItems = {
        left: [HEADER_ITEM.LOGO],
        middle: [],
        right: isLogged ? [] : [HEADER_ITEM.TO_HOZANA_LINK],
      }
      desktopItems = {
        left: [!isLogged && HEADER_ITEM.LOGO],
        middle: [],
        right: !isLogged && isHydrated ? [HEADER_ITEM.TO_HOZANA_LINK, HEADER_ITEM.LOGIN_LINK] : [],
      }
      break
  }

  return {
    mobile: { ...defaultMobileItems, ...mobileItems },
    desktop: { ...defaultDesktopItems, ...desktopItems },
    // mobileBg,
    // desktopBg,
  }
}
